import React from "react";
import { Link } from "react-router-dom";
import "../css/footer.scss";
import {
  FaLocationArrow,
  FaMobileAlt,
  FaRegEnvelope,
  FaChevronUp,
} from "react-icons/fa";

function Footer() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <footer className="site-footer" role="contentinfo">
      <div className="footer-main">
        <div className="container">
          <div className="footer-column footer-brand">
            <div className="footer-logo">
              <span>DZCP HiFi</span>
            </div>
            <ul className="contact-info">
              <li>
                <FaLocationArrow /> Mystron Technology Limited
              </li>
              <li>
                <FaMobileAlt /> Phone: +852 5436 7186
              </li>
              <li>
                <FaRegEnvelope /> Email: support@dzcp896.com
              </li>
            </ul>
          </div>

          <div className="footer-column">
            <h4 className="widget-title">USEFUL LINKS</h4>
            <ul>
              <li>
                <Link to="/privacy">Privacy Policy</Link>
              </li>
              <li>
                <Link to="/returns">Returns</Link>
              </li>
              <li>
                <Link to="/terms">Terms & Conditions</Link>
              </li>
              <li>
                <Link to="/shipping">Delivery Policy</Link>
              </li>
              <li>
                <Link to="/contact">Contact Us</Link>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container">
          <div className="copyright">
            Based on <strong>WoodMart</strong> theme &copy; 2026{" "}
            <strong>WooCommerce Themes</strong>.
          </div>
        </div>
        <button className="scroll-to-top" onClick={toTop}>
          <FaChevronUp />
        </button>
      </div>
    </footer>
  );
}

export default Footer;
